export const tradeRequestsMutations = {
  setAllTradeRequests(state, payload) {
    state.allTradeRequests = payload;
  },
  setTradeRequestFormStatus(state, payload) {
    state.tradeRequestFormStatus = payload;
  },
  setTradeRequestIsEdit(state, payload) {
    state.tradeRequestIsEdit = payload
  },
 
  setTradeRequestSelectedForEdit(state, payload) {
    state.tradeRequestSelectedForEdit = payload
  },
  setTradeRequestShowDetailForm(state, payload){
    state.tradeRequestShowDetailForm =payload
  },
  setTradeRequestSingleItem(state, payload){
    state.tradeRequestSingleItem =payload
  },
  setTradeRequestItems(state, payload){
    state.tradeRequestItems =payload
  },
  setTradeRequestSingleItemForEdit(state, payload){
    state.tradeRequestSingleItemForEdit =payload
  },
  addItemToTradeRequestItems(state, payload){
    state.tradeRequestItems.push(payload)
  },
  editItemInTradeRequestItems(state, payload) {
    console.log("mapping function is running with payload value");
    console.log(payload);
    let tempArray = [];
    tempArray.push(payload);
    console.log("tempArray");
    console.log(tempArray);
    var oldList = state.tradeRequestItems;
    //var res = arr1.map(obj => arr2.find(o => o.id === obj.id) || obj);
    state.tradeRequestItems = oldList.map(obj => tempArray.find(o => o.id === obj.id) || obj);
    //state.tradeRequestItems = res;
    console.log("state.tradeRequestItems");
    console.log(state.tradeRequestItems)
    // var editedItemInList = tradeRequestItems.find(o => o.id == payload.id);
    // state.tradeRequestItems.remove(editedItemInList);
    // state.tradeRequestItems.push(payload);
  },
  setTradeRequestSelectedForDisplay(state, payload){
    state.tradeRequestSelectedForDisplay=payload
  },
  setTradeRequestEditMode(state, payload){
    state.tradeRequestEditMode=payload
  },
   setTradeRequestItemEditMode(state, payload){
    state.tradeRequestItemEditMode=payload
  },
  setTradeRequestCategoryType(state, payload){
    state.tradeRequestCategoryType=payload
  },
  setTradeRequestResponsesPerItem(state, payload){
    state.tradeRequestResponsesPerItem=payload
  },
  setTradeRequestNumber(state, payload){
    state.tradeRequestNumber=payload
  },
  setTradeRequestDate(state, payload){
    state.tradeRequestDate=payload
  },
  setTradeRequestDate(state, payload){
    state.tradeRequestDate=payload
  },
  setTradeRequestResponsesHeader(state, payload){
    state.tradeRequestResponsesHeader=payload
  },
  setTradeRequestSelectedForResponse(state, payload){
    state.tradeRequestSelectedForResponse=payload
  },
  setTradeRequestPageNumber (state, payload){
    state.tradeRequestPageNumber=payload
  },
  setTradeRequestItemsPerPage (state, payload){
    state.tradeRequestItemsPerPage=payload
  },
  setTradeRequestSelectedItem (state, payload){
    state.tradeRequestSelectedItem=payload
  },
  setTradeRequestCurrentList (state, payload){
    state.tradeRequestCurrentList=payload
  },
  setTradeRequestCurrentList (state, payload){
    state.tradeRequestDirectCurrentList=payload
  },
  setTradeRequestSelectedToFinalize (state, payload){
    state.tradeRequestSelectedToFinalize=payload
  },
   setDirectTradeRequestSupplierId (state, payload){
    state.directTradeRequestSupplierId=payload
  },
    setDirectOrderListPageNumber (state, payload){
    state.directOrderListPageNumber=payload
  },
    setDirectOrderListItemsPerPage (state, payload){
    state.directOrderListItemsPerPage=payload
  },
};
